export default __webpack_public_path__ + "assets/archaeology-paper.c4fe1488.png";